import { render, staticRenderFns } from "./SerachStartEnd.vue?vue&type=template&id=1ff496e0&scoped=true"
import script from "./SerachStartEnd.vue?vue&type=script&lang=js"
export * from "./SerachStartEnd.vue?vue&type=script&lang=js"
import style0 from "./SerachStartEnd.vue?vue&type=style&index=0&id=1ff496e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff496e0",
  null
  
)

export default component.exports